<template>
  <div class="page left">
    <div>
      <div class="weui-msg" style="background: white">
        <img class="logo" :src="img" />
        <div class="weui-msg__text-area" style="background: white;">
          <br />
          <h2 class="weui-msg__title" style="color: black">欢迎来到众敏经管云</h2>
          <p class="weui-msg__desc" style="color: black">
            加盟合作，可联系
            19925271641，也可以直接在众敏洗车链公众号给我们留言。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: require('@/assets/omc.png'),
      ing: true,
    };
  },
  mounted() {
    let that = this;
    setTimeout((e) => {
      that.ing = false;
    }, 200);
  },
  methods: {},
};
</script>

<style>
.left {
  align-content: left;
  align-self: left;
  text-align: left;
}

li {
  color: blue;
  font: bold;
}

.logo {
  width: 30%;
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue